module.exports = __webpack_public_path__ + "static/media/shutterstock_1101884330.68a68015.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/public/images/shutterstock_1101884330.jpg
// module id = 230
// module chunks = 0